<div class="mt-4">
  <div class="row align-items-center mb-4">
    <div class="col" *ngIf="!discounts.length">
      {{ 'DISCOUNT_LIST.NO_DISCOUNTS' | translate }}
    </div>
    <div class="col">
      <button class="btn btn-primary rounded float-right"
              *ngIf="!showAddedEditedLoader"
              [title]="'DISCOUNT_LIST.ADD_NEW_DISCOUNT_TOOLTIP' | translate"
              (click)="showManagerForm(); open(addOrEditDiscountModal, 'md')">
        <i class='fa fa-plus'></i>
      </button>
    </div>
  </div>

  <div class="table-responsive" *ngIf="discounts.length">
    <table class="table table-default table-hover mb-0">
      <thead>
      <tr>
        <th scope="col">{{ 'DISCOUNT_LIST.TABLE.PROVIDER' | translate }}</th>
        <th scope="col">{{ 'DISCOUNT_LIST.TABLE.CORPORATE_DISCOUNT_CODE' | translate }}</th>
        <th scope="col">{{ 'DISCOUNT_LIST.TABLE.CORPORATE_LOYALTY_PROGRAM' | translate }}</th>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let discount of discounts | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; let idx = index"
          [class.selected-to-edit]="idx === editIdx">
        <td>{{discount.provider}}</td>
        <td>{{discount.discountCode}}</td>
        <td>{{discount.loyaltyProgramNumber}}</td>
        <td>
          <div class="d-flex gap-10">
            <i class="material-symbols-outlined"
               [title]="'DISCOUNT_LIST.EDIT_TOOLTIP' | translate"
               (click)="startEditDiscount(idx, discount);
               open(addOrEditDiscountModal, 'md')">
              edit
            </i>

            <i class="material-symbols-outlined remove-icon"
               [title]="'DISCOUNT_LIST.REMOVE_TOOLTIP' | translate"
               (click)="openRemoveModal(removeModal, discount, idx, '400px')">
              delete
            </i>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <ngb-pagination *ngIf="discounts.length > pageSize"
                  class="d-flex justify-content-end mt-4"
                  [collectionSize]="discounts.length"
                  [(page)]="page"
                  [pageSize]="pageSize"
                  [maxSize]="7"
                  [boundaryLinks]="true"
                  (pageChange)="onPageChange()"
  ></ngb-pagination>
</div>

<ng-template #addOrEditDiscountModal let-c="close" let-d="dismiss">
  <div class="modal-card card" ngbAutoFocus>
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="card-header-title">{{editIdx > -1 ? ('DISCOUNT_LIST.ADD_OR_EDIT_DISCOUNT_MODAL.EDIT' | translate) : ('DISCOUNT_LIST.ADD_OR_EDIT_DISCOUNT_MODAL.ADD' | translate)}} discount</h3>
        </div>
      </div>
    </div>
    <div class="card-body">
      <ng-container [formGroup]="discountForm">
        <div class="form-group form-group-sm">
          <label><span class="text-primary"><b>*</b></span> {{ 'DISCOUNT_LIST.ADD_OR_EDIT_DISCOUNT_MODAL.PROVIDER.LABEL' | translate }}</label>
          <app-select-airline
            class="select-airline"
            [placeholder]="'DISCOUNT_LIST.ADD_OR_EDIT_DISCOUNT_MODAL.PROVIDER.PLACEHOLDER' | translate"
            [isProviders]="true"
            [formControlName]="formControlNames.provider"
            [validate]="validateManagerTriggered"
          ></app-select-airline>
        </div>
        <div class="form-group form-group-sm"
             *ngIf="discountForm.get(formControlNames.provider).value">
          <label>{{ 'DISCOUNT_LIST.ADD_OR_EDIT_DISCOUNT_MODAL.CORPORATE_DISCOUNT_CODE.LABEL' | translate }}</label>
          <input
            type="text"
            class="form-control"
            [validate]="validateManagerTriggered"
            [formControlName]="formControlNames.discountCode"
            [placeholder]="'DISCOUNT_LIST.ADD_OR_EDIT_DISCOUNT_MODAL.CORPORATE_DISCOUNT_CODE.PLACEHOLDER' | translate"
          >
        </div>

        <div class="form-group form-group-sm"
             *ngIf="discountForm.get(formControlNames.provider).value && LOYALTY_PROGRAM_ACCOUNT_SUPPORTED_PROVIDERS.includes(discountForm.get(formControlNames.provider).value)">
          <label>{{ 'DISCOUNT_LIST.ADD_OR_EDIT_DISCOUNT_MODAL.CORPORATE_LOYALTY_PROGRAM_LABEL.LABEL' | translate }}</label>
          <input
            type="text"
            class="form-control"
            [validate]="validateManagerTriggered"
            [formControlName]="formControlNames.loyaltyProgramNumber"
            [placeholder]="'DISCOUNT_LIST.ADD_OR_EDIT_DISCOUNT_MODAL.CORPORATE_LOYALTY_PROGRAM_LABEL.PLACEHOLDER' | translate"
          >
        </div>
      </ng-container>
    </div>
    <div class="card-footer">
      <div class="btn-wrapper">
        <button class="btn btn-primary float-right ml-3"
                (click)="editIdx > -1 ? finishEditDiscount(c) : addDiscount(c)"
                [disabled]="discountForm.invalid">
          {{editIdx > -1 ? ('BUTTONS.SAVE' | translate) : ('BUTTONS.ADD' | translate)}}
        </button>
        <button class="btn btn-secondary float-right"
                (click)="cancelDiscountForm(); c('ok')"
                [disabled]="showRemovedLoader">
          {{ 'BUTTONS.CANCEL' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #removeModal let-c="close" let-d="dismiss">
  <div class="modal-card card" ngbAutoFocus>
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="card-header-title">Remove discount</h3>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="text-justify">
        Are you sure you want to remove
        {{removeDiscountInfo.discount.discountCode && removeDiscountInfo.discount.loyaltyProgramNumber ?
        'Corporate Discount Code ' + removeDiscountInfo.discount.discountCode + ' and ' + removeDiscountInfo.discount.loyaltyProgramNumber + ' Corporate Loyalty Program' :
        removeDiscountInfo.discount.discountCode ? 'Corporate Discount Code ' + removeDiscountInfo.discount.discountCode : 'Corporate Loyalty Program ' + removeDiscountInfo.discount.loyaltyProgramNumber}}
        for {{ removeDiscountInfo.discount.provider }} provider ?
      </div>
    </div>
    <div class="card-footer">
      <app-loader *ngIf="showAddedEditedLoader"></app-loader>
      <div class="btn-wrapper">
        <button (click)="removeDiscount(c);" class="btn btn-primary float-right ml-3">
          {{ 'BUTTONS.REMOVE' | translate }}
        </button>
        <button (click)="d('closed')" class="btn btn-secondary float-right"
                [disabled]="showRemovedLoader">
          {{ 'BUTTONS.CANCEL' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
